import { gql } from '@apollo/client';

const GET_HOME = gql`
  query LandingPage {
    header {
      headerButtons {
        id
        label
        variant
      }
      navigationLinks {
        id
        title
        url
      }
      headerLogo {
        id
        label
        url
        image {
          url
        }
      }
    }
    landingPage {
      blocks {
        ... on ComponentLandingHeroLandingHero {
          id
          heading
          subHeading
          backgroundImage {
            name
            url
          }
          farmButton {
            id
            label
            menuList {
              id
              item
              icon {
                name
                url
              }
              url
            }
          }
          clinicButton {
            id
            label
            menuList {
              id
              item
              icon {
                url
                name
              }
              url
            }
          }
          cardContent {
            id
            title
            subTitle
            buttonLabel
            cardList {
              id
              title
              description
            }
          }
        }
        ... on ComponentKeyBenefitsSectionKeyBenefitsSection {
          id
          Title
          buttonLabel
          tabs {
            id
            label
            slides {
              id
              title
              description
              slideImage {
                url
                name
              }
            }
          }
          description
        }
        ... on ComponentGrowthSectionGrowthSection {
          id
          title
          subTitle
          cardList {
            id
            title
            subTitle
            icon {
              name
              url
            }
            buttonLabel
          }
          backgroundImage {
            url
            name
          }
        }
        ... on ComponentFarmsVetSectionFarmsVetSection {
          id
          tabs {
            id
            label
            slides {
              id
              title
              description
              slideImage {
                url
                name
              }
            }
          }
          gallaryInfo {
            id
            description
            title
          }
          vetInfoCard {
            description
            id
            title
          }
        }
        ... on ComponentSuccessStoriesSuccessStories {
          id
          title
          subTitle
          cardList {
            id
            title
            description
            authorName
            authorDesignation
            ratings
            authorImage {
              name
              url
            }
          }
        }
        ... on ComponentDownloadApplicationDownloadApplication {
          id
          description
          slider {
            files {
              url
              name
            }
          }
          title
          playStoreImage {
            icon {
              name
              url
            }
          }
          appStoreImage {
            id
            icon {
              name
              url
            }
            url
            isExternal
          }
          backgroundImage {
            name
            url
          }
        }
        ... on ComponentScheduleSectionScheduleSection {
          id
          backgroundImage {
            name
            url
          }
          title
          buttonsList {
            id
            label
            variant
          }
          description
        }
      }
    }
    footer {
      navigationBox {
        links {
          id
          label
          url
          isExternal
        }
        title
      }
      contactInfoBox {
        infoDetailsList {
          id
          label
          icon {
            url
            name
          }
        }
        title
      }
      socialLinkBox {
        iconLinkList {
          icon {
            url
          }
          isExternal
          url
        }
      }
      downloadLinks {
        id
        url
        linkImage {
          width
          name
          url
        }
      }
      footerBottom {
        privacyLinks {
          id
          label
          url
          isExternal
        }
        copyRights
      }
      privacyPolicyContent
      termsConditionContent
    }
  }
`;
export default GET_HOME;
